
$(function(){

	var $body = $('body');
	
	/* ### open and close fitchart ### */
	$('#mm-open-fitchart').on('click', function () {

		$body.addClass('mm-fitchart-open');
		bodyFixedOn();

		$('.mm-inch').fadeIn(300);
		$('.mm-cm').fadeOut(300);

		$('.mm-overlay-close').on('click', function () {

			$body.removeClass('mm-fitchart-open');
			bodyFixedOff();
			return false;
			
		});

		/* ### swich CM and INCHES ### */
		var $fitchart = $('#mm-fitchart');
		$('.mm-scale-inch a').on('click', function () {

			$('.mm-inch').fadeIn(300);
			$('.mm-cm').fadeOut(300);
			$('.mm-scale-inch a').css('text-decoration' ,  'underline');
			$('.mm-scale-cm a').css('text-decoration' ,  'none');
		
		});
		$('.mm-scale-cm a').on('click', function () {

			$('.mm-inch').fadeOut(300);
			$('.mm-cm').fadeIn(300);
			$('.mm-scale-inch a').css('text-decoration' ,  'none');
			$('.mm-scale-cm a').css('text-decoration' ,  'underline');
	
		});

		return false;
	});

	
});



// scroll position when clicked
var scrollPosition;

// judge user agent
var ua = window.navigator.userAgent.toLowerCase();
var isiOS = ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || ua.indexOf('macintosh') > -1 && 'ontouchend' in document;

// fix scrolling
function bodyFixedOn() {
    if(isiOS){
        // iOS
        scrollPosition = $(window).scrollTop();
        $('body').css('position', 'fixed');
        $('body').css('top', '-' + scrollPosition + 'px');
    }else {
        // others
        $('body').css('overflow', 'hidden');
    }
}

// release fixed scrolling
function bodyFixedOff() {
    if(isiOS){
        // iOS
        $('body').css('position', '');
        $('body').css('top', '');
        $(window).scrollTop(scrollPosition);
    }else {
        // others
        $('body').css('overflow', '');
    }
}





